import { GeoJsonLayer } from '@deck.gl/layers';
import React, { useMemo } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import layers from './storeLayers';

const useJurisdictionGL = ({ overlay }) => {
  const onError = () => true;
  const { exact_polygon, expanded_polygon } = useSelector(
    state => state.geofences.currentGeofence,
  );

  useEffect(() => {
    if (overlay && exact_polygon && expanded_polygon) {
      // Draw the jurisdiction onto its own layer.
      // Return the data if that's what's needed for parity.

      const featureExact = {
        ...exact_polygon.features[0],
      };

      const featureExpanded = {
        ...expanded_polygon.features[0],
      };

      layers.save(
        new GeoJsonLayer({
          id: 'jurisdiction-exact-layer',
          data: featureExact,
          pickable: true,
          stroked: true,
          filled: true,
          extruded: false,
          getLineWidth: 2,
          lineWidthScale: 1,
          lineWidthMinPixels: 1,
          getFillColor: [10, 10, 10, 15],
          getLineColor: [238, 104, 92, 255],
          onError,
        }),
      );

      layers.save(
        new GeoJsonLayer({
          id: 'jurisdiction-expanded-layer',
          data: featureExpanded,
          pickable: true,
          stroked: true,
          filled: false,
          extruded: false,
          getLineWidth: 2,
          pointType: 'circle',
          lineWidthScale: 1,
          lineWidthMinPixels: 1,
          getFillColor: [10, 10, 10, 15],
          getLineColor: [36, 179, 243, 255],
          onError,
        }),
      );
      if (overlay.setProps) {
        overlay.setProps({
          layers: [layers.getAll()],
        });
      } else {
        overlay.deck.set({
          layers: [layers.getAll()],
        });
      }
    }
  }, [overlay, exact_polygon, expanded_polygon]);
};

const JurisdictionGL = ({ overlay, jurisdiction }) => {
  useJurisdictionGL({ overlay, jurisdiction });
  return <></>;
};

export default JurisdictionGL;
